module.exports = __webpack_public_path__ + "static/media/uoa-13.d16b6219.jpg";